<template>
    <v-container grid-list-md fluid class="pb-0 mb-0">
        <v-card class="default_card large mx-0 my-2 pa-2 fill-height" elevation="0">
            <v-row no-gutters mt-2 class="align-center">
                <v-col cols="4" class="d-flex justify-start align-center">
                    <v-btn-back @click="$router.push({ name: 'partitionstags-table' })"/>
                    <h1 class="ml-2">Partition générique</h1>
                </v-col>
                <v-spacer> </v-spacer>
                <v-col cols="2" class="d-flex align-center justify-end">
                    <v-btn-edit
                        v-if="currentPartitionTag.id !== 'WithoutId'"
                        :disabled="isDisabled"
                        @click="upsertPartitionTag()"
                    ></v-btn-edit>
                    <v-btn-add
                        v-else
                        :disabled="isDisabled"
                        @click="upsertPartitionTag()"
                    ></v-btn-add>
                </v-col>
            </v-row>
        </v-card>
        <v-card class="default_card_admin large">
            <v-row no-gutters color="primary">
                <v-col cols="12" class="d-flex align-center pt-3">
                    <v-text-field-filled
                        v-model="currentPartitionTagName"
                        label="Nom de la partition"
                        outlined
                        hide-details
                        data-cy="PartitionTag-nomPartition"
                        density="compact"
                    />
                </v-col>
            </v-row>
            <v-row no-gutters class="mt-2">
                <v-col cols="12" class="d-flex justify-start align-center pb-2">
                    <h2>&#xc9;tiquettes de votre partition</h2>
                </v-col>
            </v-row>
            <v-row no-gutters class="mt-2">
                <v-col cols="12">
                    <div
                        class="list-group-item item px-2 py-1 mr-2 d-flex"
                        v-for="tag in currentPartitionTag.tags"
                        style="width: fit-content !important; float: left"
                        :key="tag.id"
                        @click.stop="editTag(tag)"
                    >
                        <div class="pr-2" v-if="currentPartitionTag.type === 'Building'">
                            <v-icon dense size="x-small">$fa-building</v-icon>
                        </div>
                        <span>{{ tag.name }}</span>
                        <div class="pl-2" v-if="!disabledDeleteTag(currentPartitionTag)">
                            <v-icon v-if="tag.id" @click.stop="deleteTag(tag.id)" size="x-small"
                                >$oss-trash</v-icon
                            >
                        </div>
                    </div>
                </v-col>
                <v-col cols="11" class="d-flex pt-3">
                    <v-text-field-filled
                        v-model="newTagName"
                        label="Nom du nouveau tag"
                        color="primary"
                        outlined
                        hide-details
                        data-cy="PartitionTag-newTag"
                        density="compact"
                    />
                </v-col>
                <v-col cols="1" class="d-flex justify-center align-center pt-3">
                    <v-btn size="small" dark @click="createTag(currentPartitionTag)" icon="$add">
                    </v-btn>
                </v-col>
            </v-row>
        </v-card>
        <v-card class="default_card_admin">
            <v-row no-gutters class="mt-2">
                <v-col cols="12" class="d-flex justify-start align-center pb-2">
                    <h2>Comptes racines de votre partition</h2>
                </v-col>
                <v-col cols="12" class="d-flex justify-center">
                    <v-combobox-filled
                        v-model="currentPartitionTag.rules.rootAccountableAccounts"
                        label="Un de ces comptes racines"
                        multiple
                        outlined
                        class="mt-2"
                        dense
                        chips
                        deletable-chips
                        item-disabled
                        :rules="[rules.onlyNumbers]"
                        data-cy="PartitionTag-comptesRacines"
                    />
                </v-col>
            </v-row>
        </v-card>
        <ScopeManager
            v-model="scopeSync"
            v-model:id="scopeId"
            v-model:name="scopeName"
            :readonly="readonly"
            data-cy="PartitionTag-perimettrePartition"
        />
    </v-container>
</template>

<script lang="ts">
import { User } from "../../store/store";
import { Apollo } from "@/decorators";
import ScopeManager from "../companyScope/ScopeManager.vue";
import PARTITION_TAG_ACCOUNTING_FIRM from "../../graphql/tag/PartitionTagAccountingFirm.gql";
import UPSERT_PARTITION_TAG from "../../graphql/tag/UpsertPartitionTag.gql";
// import DELETE_TAG from "../../graphql/tag/DeleteTag.gql";
// import CREATE_FREE_TAG from "../../graphql/tag/CreateTag.gql";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";
import { Model } from "vue-facing-decorator";
import { Ref } from "vue-facing-decorator";

// import { createPartitionTag } from "../../services/tagServices"

@Component({
    components: {
        ScopeManager,
    },
})
export class PartitionTag extends Vue {
    @Model({ type: String, name: "companyScope" }) scopeSync!: any;

    selected = [];

    activeTab: string = "AccountingPlans";

    scopeName: string = "";
    scopeId_: string = "";

    partitionTagId: string = "";

    currentPartitionTag: any = {
        id: "WithoutId",
        name: "",
        companyScope: {
            id: "",
        },
        type: "AccountingFirm",
        tags: [],
        rules: {
            rootAccountableAccounts: [],
        },
    };

    accessRightPartition = {
        id: "",
        key: "AccessRight",
        type: "AccessRight",
        name: "",
        tags: [],
        rules: {
            rootAccountableAccounts: [],
        },
    };

    defaultAccessRightPartition = {
        id: "",
        key: "AccessRight",
        type: "AccessRight",
        name: "",
        tags: [],
        rules: {
            rootAccountableAccounts: [],
        },
    };

    deleteDialog: boolean = false;

    deleteLoading: boolean = false;

    toDeleteTagId: string = "";

    newTags: any = {};

    newTagName: string = "";

    currentTag: any = {};

    showTagDialog: boolean = false;

    tagLoading: boolean = false;

    currentPartitionTagName: string = "";

    // get isDisabledTagButton() {
    //     debugger;
    //     return this.currentPartitionTag.id !== "WithoutId" ? false : true;
    // }

    get isDisabled() {
        if (!this.currentPartitionTagName) {
            return true;
        }
        if(!this.scopeId) {
            return true
        }
        return false;
    }

    get tagDialogTitle() {
        return this.currentTag?.id ? "Modifier l'étiquette" : "Créer une étiquette";
    }

    get accountingFirmId() {
        return this.currentUser?.company?.id ? this.currentUser.company.id : null;
    }

    get scopeId() {
        if (this.scopeSync?.id) {
            this.scopeId_ = this.scopeSync?.id;
        }
        return this.scopeId_;
    }

    set scopeId(value) {
        this.scopeId_ = value;
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get rules() {
        return {
            notEmpty: (value) => {
                return !!value || "A remplir";
            },
            notEmptyAutocomplete: (value) => {
                if (value instanceof Array && value.length == 0) {
                    return "Il faut remplir une de ces conditions";
                }
                return !!value || "Il faut remplir une de ces conditions";
            },
            onlyNumbers: (value) => {
                for (const v of value) {
                    if (v.startsWith("0") || !/^[0-9]+$/.test(v)) {
                        return "Seuls des comptes racines sont acceptés";
                    }
                }
                return true;
            },
        };
    }

    readonly = false
    isReadOnly(accountingCompany, accountingCompanyOwner) {
        if (accountingCompany == null && accountingCompanyOwner.id !== this.accountingFirmId) {
            this.readonly = true;
        }
    }

    beforeMount() {
        if (this.$router.currentRoute.value.params.id) {
            this.partitionTagId = this.$router.currentRoute.value.params.id as string;
        }

        if (this.currentPartitionTag?.name) {
            this.currentPartitionTagName = this.currentPartitionTag.name;
        }
    }

    @Apollo({
        query() {
            return PARTITION_TAG_ACCOUNTING_FIRM;
        },
        variables() {
            return {
                id: this.partitionTagId,
            };
        },
        skip() {
            return !this.partitionTagId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                debugger;
                if (data && data.partitionTag) {
                    debugger;
                    this.partitionTag = data.partitionTag;

                    if (this.partitionTag.companyScope) {
                        const scope = this.partitionTag.companyScope
                        this.scopeId = scope.id;
                        this.scopeName = scope.name || "";
                        this.isReadOnly(scope.accountingCompany, scope.accountingCompanyOwner)
                        this.currentPartitionTagName = this.partitionTag.name;
                    } else {
                        this.scopeId = "";
                    }
                } else {
                    this.partitionTag = null;
                }
            }
        },
    })
    partitionTag = null;

    async createTag(partition) {
        const partitionId = partition.id;

        if (partitionId && this.newTagName) {
            const newTag = {
                name: this.newTagName,
                type: "External",
            };

            if (!this.createTags) {
                this.createTags = [];
            }
            this.createTags.push(newTag);

            this.currentPartitionTag.tags.push(newTag);

            this.newTagName = "";
        }
    }

    async deleteTag(tagId) {
        if (tagId) {
            if (!this.deleteTags) {
                this.deleteTags = [];
            }
            this.deleteTags.push({ id: tagId });

            this.currentPartitionTag.tags = this.currentPartitionTag.tags.filter(
                (t) => t.id !== tagId,
            );
        }
    }

    // async upsertTag() {
    //     if (this.currentTag.type === 'TagDistribution') {
    //         if (!this.currentTag || !this.currentTag.partitionTag) {
    //             debugger
    //             return true
    //         }
    //         this.tagLoading = true
    //         let percentageTags
    //         if (this.currentTag.percentageTags && this.currentTag.percentageTags.length) {
    //             percentageTags = this.currentTag.percentageTags.filter((t, index) => this.currentTag.percentages[index] !== 0).map(t => ({id:t.id}))
    //         }
    //         let percentages
    //         if (this.currentTag.percentages && this.currentTag.percentages.length) {
    //             percentages = this.currentTag.percentages.filter(p => p!==0).map(p => p*0.01)
    //         }
    //         await this.$apollo.mutate({
    //             mutation: UPSERT_TAG_DISTRIBUTION,
    //             variables: {
    //                 id: this.currentTag.id,
    //                 type: this.currentTag.type,
    //                 name: this.currentTagName,
    //                 companyId: this.companyId,
    //                 partitionTagId: this.currentTag.partitionTag ? this.currentTag.partitionTag.id: undefined,
    //                 percentages,
    //                 percentageTags,
    //                 primaryLog: this.currentTag.primaryLog || undefined

    //             }
    //         })
    //     } else if (this.currentTag.id) {
    //         await this.$apollo.mutate({
    //             mutation: UPDATE_TAG,
    //             variables: {
    //                 id: this.currentTag.id,
    //                 name: this.currentTagName
    //             }
    //         })

    //     } else {
    //         console.error("TagManager - upsertTag currentTag.id is null")
    //         return
    //     }
    //     this.refresh()
    //     this.tagLoading = false

    //     this.showTagDialog = false
    //     this.currentTag = null
    // }

    createTags: Array<{ name: string }> = [];
    deleteTags: Array<{ id: string }> = [];

    async upsertPartitionTag() {
        if (this.currentPartitionTag) {
            console.log(this.partitionTag);

            const variables = {
                id: this.currentPartitionTag.id === "WithoutId" ? "" : this.currentPartitionTag.id,
                name: this.currentPartitionTagName,
                type: this.currentPartitionTag.type,
                companyScopeId: this.scopeId,
                createTags: this.createTags,
                deleteTags: this.deleteTags,
                rules: this.currentPartitionTag.rules,
            };

            const result = await this.$apollo.mutate({
                mutation: UPSERT_PARTITION_TAG,
                variables,
            });

            // if (upsertedPartitionTag) {
            this.createTags = [];
            this.deleteTags = [];
            // this.$router.push({ name: "partitionstags-table" });
            // }
            if (this.currentPartitionTag.id === "WithoutId") {
                this.partitionTagId = result.data.upsertPartitionTag.id;
                this.$router.push({
                    name: "partitionstags-edition",
                    params: { id: result.data.upsertPartitionTag.id },
                });
            } else {
                this.refresh();
            }
        }
    }

    async refresh() {
        this.$apollo.queries.partitionTag.refetch();
    }

    @Watch("partitionTag")
    onPartitionTagChange() {
        if (this.partitionTag) {
            console.log(this.partitionTag);
            this.currentPartitionTag = JSON.parse(JSON.stringify(this.partitionTag));
            if (!this.currentPartitionTag?.rules) {
                this.currentPartitionTag.rules = {
                    rootAccountableAccounts: [],
                };
            }
        } else {
            this.currentPartitionTag = {
                id: "WithoutId",
                name: "",
                companyScope: {
                    id: "",
                },
                type: "AccountingFirm",
                tags: [],
                rules: {
                    rootAccountableAccounts: [],
                },
            };
        }
    }

    editTag(tag) {
        // if (tag) {
        //     this.currentTag = JSON.parse(JSON.stringify(tag))
        //     this.currentTag.partitionTag = partitionTag
        //     if (this.currentTag.type === "TagDistribution") {
        //         this.currentTag.percentageTags = this.currentTag.partitionTag.tags.filter(t=> t.type !== "TagDistribution")
        //         this.currentTag.percentages = new Array(this.currentTag.percentageTags.length).fill(0.0)
        //         for (let index = 0; index<tag.percentageTags.length; index++) {
        //             const percentageTag = tag.percentageTags[index]
        //             const foldedIndex =  this.currentTag.percentageTags.findIndex(t => t.id === percentageTag.id)
        //             if (foldedIndex>=0 && foldedIndex < this.currentTag.percentageTags.length) {
        //                 this.currentTag.percentages[foldedIndex] = tag.percentages[index] * 100
        //             }
        //         }
        //     }
        //     this.tagLoading = false
        //     this.showTagDialog = true
        // }
    }

    isExistingTag(key) {
        if (this.newTags[key]) {
            const name = this.newTags[key].toLowerCase();
            const tags = this.currentPartitionTag.tags;
            return !!tags.filter((x) => x.name.toLowerCase() === name).length;
        }
        return true;
    }

    disabledDeleteTag(partitionTag) {
        if (partitionTag?.type === "Building") {
            return true;
        }
        return false;
    }
}

export default toNative(PartitionTag);
</script>

<style>
.list-group-item {
    cursor: move;
}
.list-group-item i {
    cursor: pointer;
}
.item {
    background: #d1e5f9;
    border-radius: 4px;
}
</style>
